var FavouriteShopLight;
(function (FavouriteShopLight) {
    myonce('favouriteShopLight', () => {
        const $favouriteShopLight = document.querySelector('#favourite-shop-light');
        let storeRegistry = {};
        let positionCoordLat;
        let positionCoordLong;
        if ($favouriteShopLight) {
            console.log('TRUE - $favouriteShopLight');
            const $storesWrapper = $favouriteShopLight.querySelector('.favourite');
            const $storeDummy = $storesWrapper === null || $storesWrapper === void 0 ? void 0 : $storesWrapper.querySelector('.my-shop-card');
            const $offersWrapper = $favouriteShopLight.querySelector('.offers-dummy');
            const $offerDummy = $offersWrapper === null || $offersWrapper === void 0 ? void 0 : $offersWrapper.querySelector('.offer-default.dummy');
            const $servicesWrapper = $favouriteShopLight.querySelector('.wrapper-shop-online');
            const $serviceDummy = $servicesWrapper === null || $servicesWrapper === void 0 ? void 0 : $servicesWrapper.querySelector('.slide.dummy');
            const $switchClosest = $favouriteShopLight.querySelector('.switch-closest');
            const $switchFavourite = $favouriteShopLight.querySelector('.switch-favourite');
            const $titleClosest = $favouriteShopLight.querySelector('.title-closest');
            const $titleFavourite = $favouriteShopLight.querySelector('.title-favourite');
            const $subHeader = $favouriteShopLight.querySelector('.sub-head');
            const $button = $favouriteShopLight.querySelector('.container-btn');
            const $prev = $storesWrapper === null || $storesWrapper === void 0 ? void 0 : $storesWrapper.querySelector('.carousel__button--prev');
            const $next = $storesWrapper === null || $storesWrapper === void 0 ? void 0 : $storesWrapper.querySelector('.carousel__button--next');
            let activeStoreIndex = 0;
            function getSchedule(store) {
                console.log('start getSchedule');
                let result = 'Chiuso';
                let now = new Date();
                let extraordinary = store.extraordinary_schedules &&
                    store.extraordinary_schedules.find((extraDay) => {
                        let extraDayTime = new Date(extraDay.date);
                        return (extraDayTime.getFullYear() +
                            '/' +
                            extraDayTime.getMonth() +
                            '/' +
                            extraDayTime.getDate() ===
                            now.getFullYear() + '/' + now.getMonth() + '/' + now.getDate());
                    });
                let ordinary = store.schedules &&
                    store.schedules.find((ordDay) => {
                        return now.getDay() + 1 === ordDay.dayOfTheWeek;
                    });
                let checkDay = extraordinary || ordinary;
                let searchNextDay = false;
                if (checkDay && checkDay.status) {
                    let daySegments = checkDay.value.split(';').map((segment) => {
                        return segment.split('-');
                    });
                    let isOpen = false;
                    let afterSegments = [];
                    daySegments.forEach((segment, index) => {
                        let startDate = new Date();
                        startDate.setHours(segment[0].split(':')[0]);
                        startDate.setMinutes(segment[0].split(':')[1]);
                        startDate.setSeconds(0);
                        let endDate = new Date();
                        endDate.setHours(segment[1].split(':')[0]);
                        endDate.setMinutes(segment[1].split(':')[1]);
                        endDate.setSeconds(0);
                        afterSegments[index] = now > endDate;
                        if (now >= startDate && now <= endDate) {
                            isOpen = true;
                            result = 'Aperto ora - Chiusura: ' + segment[1];
                        }
                    });
                    if (!isOpen) {
                        let segmentIndex = afterSegments.indexOf(false);
                        if (segmentIndex > 0) {
                            result += ' - Apertura: ' + daySegments[segmentIndex][0];
                        }
                        else {
                            searchNextDay = true;
                        }
                    }
                }
                else {
                    searchNextDay = true;
                }
                if (searchNextDay) {
                    let nextDayDate = new Date();
                    let nextIndex = 1;
                    let nextDay;
                    while (!nextDay && nextIndex <= 7) {
                        nextDayDate.setDate(now.getDate() + nextIndex);
                        let nextExtraordinary = store.extraordinary_schedules &&
                            store.extraordinary_schedules.find((extraDay) => {
                                let extraDayTime = new Date(extraDay.date);
                                return (extraDayTime.getFullYear() +
                                    '/' +
                                    extraDayTime.getMonth() +
                                    '/' +
                                    extraDayTime.getDate() ===
                                    nextDayDate.getFullYear() +
                                        '/' +
                                        nextDayDate.getMonth() +
                                        '/' +
                                        nextDayDate.getDate());
                            });
                        let nextOrdinary = store.schedules &&
                            store.schedules.find((ordDay) => {
                                return nextDayDate.getDay() + 1 === ordDay.dayOfTheWeek;
                            });
                        let nextCheckDay = nextExtraordinary || nextOrdinary;
                        if (nextCheckDay && nextCheckDay.status) {
                            nextDay = nextCheckDay;
                            nextDay.date = nextDayDate;
                        }
                        else {
                            nextIndex++;
                        }
                    }
                    if (nextDay) {
                        let days = [
                            'Domenica',
                            'Lunedì',
                            'Martedì',
                            'Mercoledì',
                            'Giovedì',
                            'Venerdì',
                            'Sabato',
                        ];
                        let dayName = days[nextDay.date.getDay()];
                        let openingTime = nextDay.value.split('-')[0];
                        result += ' - Apertura: ' + dayName + ' ' + openingTime;
                    }
                }
                console.log('exit getSchedule');
                return result;
            }
            function showSearch() {
                var _a;
                (_a = $favouriteShopLight === null || $favouriteShopLight === void 0 ? void 0 : $favouriteShopLight.querySelector('.no-shop')) === null || _a === void 0 ? void 0 : _a.classList.add('is-active');
            }
            function retrieveConfig($wrapper) {
                console.log('start retrieveConfig');
                let data = {
                    url: '',
                    config: {},
                };
                const $form = $wrapper && $wrapper.querySelector('.ep-config');
                if ($form) {
                    try {
                        const url = $form.querySelector('[name="url"]').value;
                        const config = $form.querySelector('[name="config"]').value;
                        data = {
                            url: url.replace(/\/$/, ''),
                            config: JSON.parse(config),
                        };
                    }
                    catch (e) {
                        console.log('Error during retrieval of configuration for current service. %s', e);
                    }
                }
                console.log('end retrieveConfig');
                return data;
            }
            function getClosestShop({ latitude, longitude }) {
                return new Promise((resolve, reject) => {
                    let closestStore = JSON.parse(sessionStorage.getItem('closest-store'));
                    if (!closestStore) {
                        const config = retrieveConfig($favouriteShopLight);
                        Fetch('/api/esb/storelocator/searchStores?_format=form', {
                            method: 'POST',
                            data: {
                                coords: {
                                    latitude,
                                    longitude,
                                },
                            },
                            token: { enable: true },
                        })
                            .then((response) => {
                            resolve(response);
                            if (response.result === 'OK') {
                                sessionStorage.setItem('closest-store', JSON.stringify(response));
                            }
                        })
                            .catch(() => {
                            reject();
                        });
                    }
                    else {
                        resolve(closestStore);
                    }
                });
            }
            function getStores(getClosest) {
                console.log('start getstores');
                $storesWrapper === null || $storesWrapper === void 0 ? void 0 : $storesWrapper.setAttribute('data-spinner', '');
                return new Promise((resolve, reject) => {
                    localforage.getItem('favourite_store').then((stores) => {
                        if (stores && stores.length && !getClosest) {
                            resolve(stores);
                            $titleFavourite === null || $titleFavourite === void 0 ? void 0 : $titleFavourite.classList.remove('d-none');
                            getCoords()
                                .then((position) => {
                                if (position.coords) {
                                    $switchClosest === null || $switchClosest === void 0 ? void 0 : $switchClosest.classList.add('is-active');
                                    $subHeader === null || $subHeader === void 0 ? void 0 : $subHeader.classList.remove('d-none');
                                }
                            })
                                .catch(() => {
                                $subHeader === null || $subHeader === void 0 ? void 0 : $subHeader.classList.add('d-none');
                            });
                        }
                        else {
                            $titleClosest === null || $titleClosest === void 0 ? void 0 : $titleClosest.classList.remove('d-none');
                            $subHeader === null || $subHeader === void 0 ? void 0 : $subHeader.classList.remove('d-none');
                            getCoords()
                                .then((position) => {
                                getClosestShop(position.coords)
                                    .then((response) => {
                                    if (response &&
                                        response.header.result === 'OK' &&
                                        response.payload.stores.length) {
                                        resolve([response.payload.stores[0]]);
                                    }
                                    else {
                                        reject();
                                    }
                                })
                                    .catch(() => {
                                    reject();
                                })
                                    .finally(() => {
                                    localforage
                                        .getItem('favourite_store')
                                        .then((stores) => {
                                        if (stores && stores.length) {
                                            $switchFavourite === null || $switchFavourite === void 0 ? void 0 : $switchFavourite.classList.add('is-active');
                                        }
                                    });
                                });
                            })
                                .catch(() => {
                                showSearch();
                                $switchClosest.classList.remove('is-active');
                                $switchFavourite.classList.remove('is-active');
                                reject();
                            });
                        }
                    });
                }).finally(() => {
                    $storesWrapper === null || $storesWrapper === void 0 ? void 0 : $storesWrapper.removeAttribute('data-spinner');
                    console.log('exit getstores');
                });
            }
            function getOffers(coopId, pdvId) {
                return new Promise((resolve) => {
                    let offers = JSON.parse(sessionStorage.getItem('offers-cache')) || {};
                    if (offers[pdvId]) {
                        resolve(offers[pdvId]);
                    }
                    else {
                        const config = retrieveConfig($favouriteShopLight);
                        Fetch('/api/esb/storelocator/getStoreDetail?_format=form', {
                            method: 'POST',
                            data: {
                                storeId: [pdvId],
                            },
                            token: { enable: true },
                        })
                            .then((response) => {
                            if (response && response.header.result === 'OK') {
                                offers[pdvId] = [];
                                response.payload.stores[0].flyers.forEach((offer) => {
                                    offers[pdvId].push(offer);
                                });
                                sessionStorage.setItem('offers-cache', JSON.stringify(offers));
                                return response.payload.stores[0].flyers;
                            }
                            else {
                                return [];
                            }
                        })
                            .catch(() => {
                            return [];
                        })
                            .then((offers) => {
                            resolve(offers);
                        });
                    }
                });
            }
            function getServices(id, { latitude, longitude }) {
                return new Promise((resolve) => {
                    let services = JSON.parse(sessionStorage.getItem('services-cache')) || {};
                    if (services[id]) {
                        resolve(services[id]);
                    }
                    else {
                        getZipCode({ latitude, longitude })
                            .then((zipCode) => {
                            return zipCode || '';
                        })
                            .catch(() => { }) 
                            .then((zipCode) => {
                            const config = retrieveConfig($favouriteShopLight);
                            Fetch('/api/esb/geolink/getGeoLinks?_format=form', {
                                method: 'POST',
                                data: {
                                    latitude,
                                    longitude,
                                    zipCode,
                                    type: 'HP',
                                },
                                token: { enable: true },
                            })
                                .then((response) => {
                                if (response && response.header.result === 'OK') {
                                    services[id] = [];
                                    response.payload.services.forEach((service) => {
                                        services[id].push(service);
                                    });
                                    sessionStorage.setItem('services-cache', JSON.stringify(services));
                                    return response.payload.services;
                                }
                                else {
                                    return [];
                                }
                            })
                                .catch(() => {
                                return [];
                            })
                                .then((services) => {
                                resolve(services);
                            });
                        });
                    }
                });
            }
            function buildStoreHtml($dummy, store) {
                const $store = $dummy.cloneNode(true);
                getCoords()
                    .then((position) => {
                    positionCoordLat = position.coords.latitude;
                    positionCoordLong = position.coords.longitude;
                    $store.querySelector('.promotion-wrapper .links .directions').href = `https://www.google.it/maps/dir/${positionCoordLat},${positionCoordLong}/${store.geo.latitude},${store.geo.longitude}`;
                    initLink();
                })
                    .catch((e) => {
                    console.log(e);
                    $store.querySelector('.promotion-wrapper .links .directions').href = `https://www.google.it/maps/dir//${store.geo.latitude},${store.geo.longitude}`;
                });
                $store.classList.remove('dummy');
                $store.setAttribute('data-id', store.id);
                if ($store) {
                    $store.querySelector('.name').innerHTML = store.name;
                }
                if (store.logo) {
                    $store.querySelector('.logo').src = store.logo;
                    $store.querySelector('.logo').alt = `logo`;
                }
                if ($store) {
                    $store.querySelector('.shop-address').innerHTML =
                        store.address;
                    $store.querySelector('.shop-phone a').href = `tel:${store.phone}`;
                    $store.querySelector('.shop-phone a').innerHTML = `${store.phone}`;
                    $store.querySelector('.shop-hours').innerHTML =
                        getSchedule(store);
                }
                $store.querySelector('.promotion-wrapper .links .storePage').href = `/spesa-e-servizi/punti-vendita/${store.id}/${store.name
                    .replace(/[^a-zA-Z0-9\s\-_]/gim, '')
                    .replace(/\s/gim, '-')}`;
                const id = $store.getAttribute('data-id');
                localforage.getItem('favourite_store').then((stores) => {
                    var _a;
                    if (stores && stores.filter((s) => s.id == id).length) {
                        (_a = $store
                            .querySelector('.favourite-shop-light')) === null || _a === void 0 ? void 0 : _a.classList.add('is-favourite');
                    }
                });
                storeRegistry[store.id] = store;
                return $store;
            }
            function bindActionsFavourite() {
                console.log('start bindActionsFav');
                const $stores = $favouriteShopLight === null || $favouriteShopLight === void 0 ? void 0 : $favouriteShopLight.querySelectorAll('.my-shop-card:not(.dummy)');
                $stores === null || $stores === void 0 ? void 0 : $stores.forEach(($store) => {
                    const $hearth = $store.querySelector('.favourite-shop-light');
                    $hearth === null || $hearth === void 0 ? void 0 : $hearth.addEventListener('click', () => {
                        const id = $store.getAttribute('data-id');
                        if ($hearth.classList.contains('is-favourite')) {
                            removeFavouriteStore(storeRegistry[id]);
                        }
                        else {
                            addFavouriteStore(storeRegistry[id]);
                        }
                        $hearth.classList.toggle('is-favourite');
                    });
                });
                console.log('end bindActionsFav');
            }
            function addFavouriteStore(store) {
                console.log('start addfav');
                localforage.getItem('favourite_store').then((stores) => {
                    stores = stores || [];
                    stores.push(store);
                    localforage.setItem('favourite_store', stores);
                });
                console.log('start addfav');
            }
            function removeFavouriteStore(store) {
                console.log('rem favstore start');
                localforage.getItem('favourite_store').then((stores) => {
                    stores = stores || [];
                    localforage.setItem('favourite_store', stores.filter((s) => store.id !== s.id));
                });
                console.log('rem favstore end');
            }
            function buildOffersHtml(offers) {
                const $carousel = $offersWrapper === null || $offersWrapper === void 0 ? void 0 : $offersWrapper.querySelector('.train-card');
                const $slideContainer = $offersWrapper === null || $offersWrapper === void 0 ? void 0 : $offersWrapper.querySelector('.slide-container');
                if ($slideContainer) {
                    $slideContainer.innerHTML = '';
                }
                if (offers.length) {
                    offers.forEach((offer) => {
                        let $offer = $offerDummy === null || $offerDummy === void 0 ? void 0 : $offerDummy.cloneNode(true);
                        if (offer.cover && offer.description) {
                            $offer.id = offer.idPromoRow;
                            $offer.querySelector('.image').style.backgroundImage = `url(${offer.cover})`;
                            $offer.querySelector('.card').href = offer.url;
                            if ($offer) {
                                $offer.querySelector('.container-text .title').innerHTML = offer.description;
                            }
                            $offer.querySelector('.container-text .description').innerHTML = `Dal ${moment(offer.startDate).format('DD/MM/yyyy')} al ${moment(offer.endDate).format('DD/MM/yyyy')}`;
                            $offersWrapper.querySelector('.slide-container').appendChild($offer);
                            $offer.classList.remove('dummy');
                        }
                        else {
                            viewOfferDefault(offer);
                            console.log('buildOffersHtml(offers) -> viewOfferDefault(offer)');
                        }
                        let $offersDefault = $storesWrapper.querySelector('.offers-default');
                        $offersDefault.appendChild($offersWrapper);
                    });
                    $offersWrapper === null || $offersWrapper === void 0 ? void 0 : $offersWrapper.classList.add('is-active');
                }
                else {
                    $offersWrapper === null || $offersWrapper === void 0 ? void 0 : $offersWrapper.classList.remove('is-active');
                }
                $offersWrapper === null || $offersWrapper === void 0 ? void 0 : $offersWrapper.removeAttribute('data-spinner');
                trigger(document, 'init-train-card', $carousel);
            }
            function viewOfferDefault(offer) {
                console.log('viewOfferDefault');
                let $noResultOffer = $offersWrapper === null || $offersWrapper === void 0 ? void 0 : $offersWrapper.querySelector('.is-default-content');
                if ($noResultOffer) {
                    $noResultOffer = $noResultOffer.cloneNode(true);
                    $noResultOffer.classList.remove('dummy');
                    if (offer) {
                        $noResultOffer.querySelector('.card').href = offer.url;
                    }
                    if ($offersWrapper) {
                        console.log('pre-append');
                        $offersWrapper.querySelector('.slide-container').appendChild($noResultOffer);
                    }
                    $offersWrapper === null || $offersWrapper === void 0 ? void 0 : $offersWrapper.classList.add('is-active');
                    console.log('$offersWrapper.classList.add is-active');
                }
                else {
                    $offersWrapper === null || $offersWrapper === void 0 ? void 0 : $offersWrapper.classList.remove('is-active');
                    console.log('$offersWrapper.classList.remove is-active');
                }
            }
            function buildServicesHtml(services) {
                const $carousel = $servicesWrapper === null || $servicesWrapper === void 0 ? void 0 : $servicesWrapper.querySelector('.train-card');
                const $slideContainer = $servicesWrapper === null || $servicesWrapper === void 0 ? void 0 : $servicesWrapper.querySelector('.slide-container');
                if ($slideContainer) {
                    $slideContainer.innerHTML = '';
                }
                if (services.length) {
                    services.forEach((service) => {
                        var _a;
                        const $service = $serviceDummy === null || $serviceDummy === void 0 ? void 0 : $serviceDummy.cloneNode(true);
                        $service.id = service.id;
                        if (service.image) {
                            $service.querySelector('.image').src =
                                service.image;
                        }
                        $service.querySelector('.card-link').href =
                            service.link;
                        if ($service) {
                            $service.querySelector('.card-description').innerHTML = service.text;
                        }
                        $service.classList.remove('dummy');
                        (_a = $servicesWrapper === null || $servicesWrapper === void 0 ? void 0 : $servicesWrapper.querySelector('.slide-container')) === null || _a === void 0 ? void 0 : _a.appendChild($service);
                    });
                    $servicesWrapper === null || $servicesWrapper === void 0 ? void 0 : $servicesWrapper.classList.add('is-active');
                    $servicesWrapper === null || $servicesWrapper === void 0 ? void 0 : $servicesWrapper.removeAttribute('data-spinner');
                    trigger(document, 'init-train-card', $carousel);
                }
                else {
                    $servicesWrapper === null || $servicesWrapper === void 0 ? void 0 : $servicesWrapper.classList.remove('is-active');
                }
            }
            function build(stores) {
                console.log('start build');
                const storesLen = stores.length;
                stores.forEach((store) => {
                    var _a;
                    const carouselItem = document.createElement('div');
                    const $store = buildStoreHtml($storeDummy, store);
                    carouselItem.className = 'carousel__item';
                    carouselItem.appendChild($store);
                    (_a = $storesWrapper === null || $storesWrapper === void 0 ? void 0 : $storesWrapper.querySelector('.carousel')) === null || _a === void 0 ? void 0 : _a.appendChild(carouselItem);
                });
                console.log('pre init');
                initCarousel();
                console.log('end init');
                bindActionsFavourite();
                console.log('exit bind');
                const activeStore = stores[activeStoreIndex];
                getOffers(activeStore.coopId, activeStore.id).then((promos) => {
                    buildOffersHtml(promos);
                });
                getServices(activeStore.id, activeStore.geo).then((services) => {
                    buildServicesHtml(services);
                });
                if (storesLen > 1) {
                    $next === null || $next === void 0 ? void 0 : $next.classList.remove('hidden');
                    $prev === null || $prev === void 0 ? void 0 : $prev.classList.remove('hidden');
                    $next === null || $next === void 0 ? void 0 : $next.removeEventListener('click', () => { });
                    $next === null || $next === void 0 ? void 0 : $next.addEventListener('click', () => {
                        activeStoreIndex = (activeStoreIndex + 1) % storesLen;
                        const activeStore = stores[activeStoreIndex];
                        getOffers(activeStore.coopId, activeStore.id).then((promos) => {
                            buildOffersHtml(promos);
                        });
                        getServices(activeStore.id, activeStore.geo).then((services) => {
                            buildServicesHtml(services);
                        });
                    });
                    $prev === null || $prev === void 0 ? void 0 : $prev.removeEventListener('click', () => { });
                    $prev === null || $prev === void 0 ? void 0 : $prev.addEventListener('click', () => {
                        activeStoreIndex = (activeStoreIndex - 1) % storesLen;
                        activeStoreIndex = activeStoreIndex < 0 ? storesLen - 1 : activeStoreIndex;
                        const activeStore = stores[activeStoreIndex];
                        getOffers(activeStore.coopId, activeStore.id).then((promos) => {
                            buildOffersHtml(promos);
                        });
                        getServices(activeStore.id, activeStore.geo).then((services) => {
                            buildServicesHtml(services);
                        });
                    });
                }
                else {
                    $next === null || $next === void 0 ? void 0 : $next.classList.add('hidden');
                    $prev === null || $prev === void 0 ? void 0 : $prev.classList.add('hidden');
                }
            }
            function reset(getClosest) {
                $offersWrapper === null || $offersWrapper === void 0 ? void 0 : $offersWrapper.classList.remove('is-active');
                $servicesWrapper === null || $servicesWrapper === void 0 ? void 0 : $servicesWrapper.classList.remove('is-active');
                if ($storesWrapper) {
                    $storesWrapper.querySelector('.carousel').innerHTML = '';
                }
                if ($offersWrapper) {
                    $offersWrapper.querySelector('.slide-container').innerHTML =
                        '';
                }
                if ($servicesWrapper) {
                    $servicesWrapper.querySelector('.slide-container').innerHTML =
                        '';
                }
                getStores(getClosest).then((stores) => {
                    build(stores);
                });
            }
            function init() {
                getStores()
                    .then((stores) => {
                    console.log('INIT-GETSTORES-THEN');
                    build(stores);
                    $button === null || $button === void 0 ? void 0 : $button.classList.remove('d-none');
                })
                    .catch(() => {
                    console.log('INIT-CATCH');
                    showSearch();
                    $switchClosest.classList.remove('is-active');
                    $switchFavourite.classList.remove('is-active');
                    $button.classList.add('d-none');
                })
                    .finally(() => {
                    var _a;
                    (_a = $favouriteShopLight === null || $favouriteShopLight === void 0 ? void 0 : $favouriteShopLight.querySelector('.no-shop')) === null || _a === void 0 ? void 0 : _a.removeAttribute('data-spinner');
                    $switchClosest === null || $switchClosest === void 0 ? void 0 : $switchClosest.addEventListener('click', () => {
                        $switchClosest.classList.remove('is-active');
                        $titleFavourite === null || $titleFavourite === void 0 ? void 0 : $titleFavourite.classList.add('d-none');
                        $titleClosest === null || $titleClosest === void 0 ? void 0 : $titleClosest.classList.remove('d-none');
                        $next === null || $next === void 0 ? void 0 : $next.classList.add('d-none');
                        $prev === null || $prev === void 0 ? void 0 : $prev.classList.add('d-none');
                        reset(true);
                    });
                    $switchFavourite === null || $switchFavourite === void 0 ? void 0 : $switchFavourite.addEventListener('click', () => {
                        $switchFavourite.classList.remove('is-active');
                        $titleFavourite === null || $titleFavourite === void 0 ? void 0 : $titleFavourite.classList.remove('d-none');
                        $titleClosest === null || $titleClosest === void 0 ? void 0 : $titleClosest.classList.add('d-none');
                        $next === null || $next === void 0 ? void 0 : $next.classList.remove('d-none');
                        $prev === null || $prev === void 0 ? void 0 : $prev.classList.remove('d-none');
                        reset(false);
                    });
                });
            }
            init();
        }
    });
})(FavouriteShopLight || (FavouriteShopLight = {}));
